import PtimHero from "./components/PtimHero";
import PtimWhatIs from "./components/PtimWhatIs";
import PtimProcess from "./components/PtimProcess";
import PtimWhyItMatters from "./components/PtimWhyItMatters";
import PtimPathwayNav from "./components/PtimPathwayNav";
import PtimOutcomes from "./components/PtimOutcomes";

export default function Ptim() {
  return (
    <main className="min-h-screen">
      <PtimHero />
      <PtimWhatIs />
      <PtimProcess />
      <PtimWhyItMatters />
      <PtimPathwayNav />
      <PtimOutcomes />
    </main>
  );
}